module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_BatteryHigh_16"],"path":[{"$":{"d":"M15,6V4H0v8H15V10h1V6ZM14,9H13v2H2V5H13V7h1ZM3,6h7v4H3Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_BatteryHigh_16.svg
// module id = Zrhs
// module chunks = 1